import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';
import { User } from 'src/app/component/auth/model/user.model';

import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { LoginAudit } from '../model/login-audit';
import { LoginDetailStatusType } from '../model/login-Detail-status';
import { PasswordChange } from '../model/password-change-data-view';
import { AccountSearchRequestDataView } from '../model/search-account-request-data-view';
import { UserModel } from '../model/user';
import { AuthService } from 'src/app/component/auth/service/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AccountService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService, authService: AuthService) {
        super(http, urlProvider);
    }

    getAccountSearchV2(requestPayload: AccountSearchRequestDataView): Observable<any> {
        return this.post<any>(EndPoints.accounts_search, false, '', requestPayload).pipe(
            switchMap((result) => {
                return of(result);
            })
        );
    }

    getAccount(requestPayload: any): Observable<UserModel> {
        return this.post<any>(EndPoints.accounts_show, false, '', requestPayload).pipe(
            switchMap((result) => {
                return of(result['user']);
            })
        );
    }

    getPasswordChangeInformation(userId: number): Observable<PasswordChange> {
        return this.get<PasswordChange>(EndPoints.accounts_password_change_information, '', userId);
    }

    getLoginDetailStatusTypes(): Observable<LoginDetailStatusType[]> {
        return this.get<any>(EndPoints.accounts_loginDetailStatus).pipe(
            switchMap((result) => {
                return of(result['loginDetailStatusTypes']);
            })
        );
    }

    getLoginAudits(requestPayload: any): Observable<LoginAudit[]> {
        return this.post<any>(EndPoints.acounts_post_loginAudit, false, '', requestPayload).pipe(
            switchMap((result: any) => {
                return of(JSON.parse(result['loginAudits']));
            })
        );
    }

    updateAccountContactInfo(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.accounts_update_contactInfo, false, '', requestPayload).pipe(
            switchMap((result: any) => {
                return of(result);
            })
        );
    }
    updateAccountStatus(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.accounts_update_status, false, '', requestPayload).pipe(
            switchMap((result: any) => {
                return of(result);
            })
        );
    }    

    updateRegionOrganization(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.accounts_update_Organization, false, '', requestPayload).pipe(
            switchMap((result: any) => {
                return of(result);
            })
        );
    }

    UpdateUserRoles(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.accounts_update_UserRoles, false, '', requestPayload).pipe(
            switchMap((result: any) => {
                return of(result);
            })
        );
    }

    accountRegister(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.account_register, false, '', requestPayload).pipe(
            switchMap((result: any) => {
                return of(result);
            })
        );
    }

    getSessionCount(): Observable<any> {
        return this.post<any>(EndPoints.accounts_SessionCount, false, '', {}).pipe(
            switchMap((result: any) => {
                return of(result);
            })
        );
    }

    resetPassword(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.accounts_ResetPassword, false, '', requestPayload).pipe(
            switchMap((result: any) => {
                return of(result);
            })
        );
    }

    // super admin removeSessions for GlobalAdmin screen
    removeSessions(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.accounts_RemoveSessions, false, '', requestPayload).pipe(
            switchMap((result: any) => {
                console.log('result:', result);
                return of(result);
            })
        );
    }

    // called from other-sessions-active.component
    removeOtherSessions(): Observable<string> {
        return this.get<any>(EndPoints.accounts_RemoveOtherSessions);
    }

    reCreateNewUser(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.accounts_ReCreateNewUser, false, '', requestPayload).pipe(
            switchMap((result: any) => {
                return of(result);
            })
        );
    }

    checkAccountStatus(userId: number): Observable<any> {
        return this.get<any>(EndPoints.accounts_checkAccountStatus, '', userId);
    }

    checkFeature(feature: string): Observable<any> {
        return this.post<any>(EndPoints.account_checkFeature, false, '', {
            feature: feature
        });
    }
}
